export default function Home() {
    return (
        <div>
            <header className="bg-[#073165] p-6 md:p-12 text-center">
                <h1 className="text-white font-bold text-2xl md:text-4xl">BEM VINDO AO GRUPO IMIGRANTES!</h1>
            </header>
            <div className="flex flex-col xl:flex-row gap-10 justify-center items-center p-4">
                <div className="w-full max-w-[660px]">
                    <div className="bg-white rounded-xl p-6 w-full mt-6 md:mt-10">
                        <div className="flex items-center gap-10 text-center">
                            <img src="./assets/logoImigrantes.png" alt="Auto Shopping Imigrantes" className="w-40 md:w-fit"/>
                            <a className="bg-[#3563E9] p-2 rounded-lg text-white transition-transform hover:scale-110" href="https://autoshoppingimigrantes.com.br/#/">Compre seu veículo!</a>
                        </div>
                        <div className="flex justify-center mt-4">
                            <img src="./assets/carro1.png" alt="Veiculo1" />
                        </div>
                    </div>
                    <h2 className="text-white text-center text-lg md:text-xl font-bold mt-4">Av. do Estado, 1400 <br /> Fundação - São Caetano do Sul - SP</h2>
                </div>
                
                <div className="w-full max-w-[660px]">
                    <div className="bg-white rounded-xl p-[36px] w-full mt-6 md:mt-10">
                        <div className="flex items-center gap-4 text-center">
                            <img src="./assets/logoCentral.png" alt="Auto Shopping Central" className="w-40 md:w-fit"/>
                            <a className="bg-[#3563E9] p-2 rounded-lg text-white transition-transform hover:scale-110" href="https://autoshoppingcentral.com.br/#/">Compre seu veículo!</a>
                        </div>
                        <div className="flex justify-center mt-4">
                            <img src="./assets/carro2.png" alt="Veiculo2" />
                        </div>
                    </div>
                    <h2 className="text-white text-center text-lg md:text-xl font-bold mt-4">Rua Marechal Deodoro, 2785 <br /> Centro - São Bernardo do Campo - SP</h2>
                </div>
            </div>
        </div>
    )
}
